
import { string, boolean, object, mixed,number } from "yup";

export const DepotSchema = object({
    libelle: string().required('libelle obligatoire !'),
});